// extracted by mini-css-extract-plugin
export default {"cards":"Ks8wKNQRlPsgHerb5I2f"};